import React from 'react';
import useStyle from './dashboardContent.style';
import { ContainerHalf } from 'components/layouts/ContainerHalf';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { FeatureMyRank } from 'components/organisms/Features/FeatureMyRank';
import { FeatureMyClass } from 'components/organisms/Features/FeatureMyClass';
import { FeatureMySkills } from 'components/organisms/Features/FeatureMySkills';
import { FeatureQuiz } from 'components/organisms/Features/FeatureQuiz';
import { TableMyResult } from 'components/organisms/Table/TableMyResult';
import LeaderBoards from 'views/Dashboard/LeaderBoards';
import { IS_PROF } from '../../../../helpers/user/authorization';
import { classNames } from '../../../../helpers/style/classNames';
import { ChangeClassBlock } from 'components/molecules/Blocks/ChangeClassBlock';
import { EspaceProfBlock } from 'components/molecules/Blocks/EspaceProfBlock';
import RaidChallengeBlock from 'components/molecules/Blocks/RaidChallengeBlock';

interface DashboardContentProps {
  goToEspaceProf: () => void;
  goToControlTab: () => void;
}

export const DashboardContent = ({
  goToEspaceProf,
  goToControlTab
}: DashboardContentProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <RaidChallengeBlock />
      <ContainerHalf
        col1={
          <ContainerHalf
            col1={
              IS_PROF ? (
                <div className={classes.buttonContainer}>
                  <ChangeClassBlock />
                  <EspaceProfBlock
                    variant="Dashboard"
                    onClick={goToEspaceProf}
                  />
                  <EspaceProfBlock
                    variant="Dashboard"
                    content="controlTab"
                    onClick={goToControlTab}
                  />
                </div>
              ) : (
                <FeatureMyRank showAcademie={false} />
              )
            }
            col2={<FeatureMyClass />}
          />
        }
        col2={<TableMyResult />}
        variant="dashboard"
      />
      <ContainerTwoThirds
        col1={<LeaderBoards />}
        col2={
          <div
            className={classNames(
              [],
              [
                { condition: IS_PROF, classe: classes.actuQuiz },
                { condition: !IS_PROF, classe: classes.competences }
              ]
            )}
          >
            {IS_PROF ? <FeatureQuiz /> : <FeatureMySkills />}
          </div>
        }
        variant="dashboard"
      />
    </div>
  );
};
